import { render, staticRenderFns } from "./BMCLog.vue?vue&type=template&id=77f30179"
import script from "./BMCLog.vue?vue&type=script&lang=js"
export * from "./BMCLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports